<div class="auth-modal-shell" role="dialog" aria-modal="true" [attr.aria-label]="title" (click)="onBackdropClick()">
  <div class="auth-modal-shell__panel" (click)="$event.stopPropagation()">
    <div class="auth-modal-shell__head">
      <h2 class="auth-modal-shell__title">{{ title }}</h2>
      <button
        *ngIf="showCloseButton"
        type="button"
        class="auth-modal-shell__close"
        aria-label="Close"
        (click)="onCloseClick()"
      >
        ×
      </button>
    </div>
    <div class="auth-modal-shell__body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
